// @owners { team: patients }
import { Column, MdSpacing } from '@alto/design-system';
import React, { useState } from 'react';
import { BenefitCardPhotoPreview } from './BenefitCardPhotoPreview';
import { ImageUploadListButton } from '~web/components/ImageUploadListButton';

export type UploadImageProps = {
  readonly disabled?: boolean;
  readonly loading: boolean;
  readonly onFormChange: (name: 'image_url' | 'image_url_2', file: File[]) => void;
  readonly initialFrontImageUrl: string;
  readonly initialBackImageUrl: string;
};

export const InsurancePhotoUploadButtons = ({
  disabled,
  loading,
  onFormChange,
  initialFrontImageUrl,
  initialBackImageUrl,
}: UploadImageProps) => {
  const [cardFront, setCardFront] = useState<string>(initialFrontImageUrl);
  const [cardBack, setCardBack] = useState<string>(initialBackImageUrl);

  const handleCardFrontFileChange = (file: File) => {
    onFormChange('image_url', [file]);
    const imgString = URL.createObjectURL(file);
    setCardFront(imgString);
  };

  const handleCardBackFileChange = (file: File) => {
    onFormChange('image_url_2', [file]);
    const imgString = URL.createObjectURL(file);
    setCardBack(imgString);
  };

  const handleCardFrontDelete = () => {
    onFormChange('image_url', []);
    setCardFront('');
  };

  const handleCardBackDelete = () => {
    onFormChange('image_url_2', []);
    setCardBack('');
  };

  return (
    <Column>
      {cardFront ? (
        <BenefitCardPhotoPreview
          disabled={disabled}
          loading={loading}
          onDelete={handleCardFrontDelete}
          sideOfCard="front"
          source={cardFront}
        />
      ) : (
        <ImageUploadListButton
          name="benefit-card-front"
          onUpload={handleCardFrontFileChange}
          source={cardFront}
          loading={loading}
          disabled={disabled}
        >
          Upload front of card
        </ImageUploadListButton>
      )}
      <MdSpacing />
      {cardBack ? (
        <BenefitCardPhotoPreview
          disabled={disabled}
          loading={loading}
          onDelete={handleCardBackDelete}
          sideOfCard="back"
          source={cardBack}
        />
      ) : (
        <ImageUploadListButton
          name="benefit-card-back"
          onUpload={handleCardBackFileChange}
          source={cardBack}
          loading={loading}
          disabled={disabled}
        >
          Upload back of card
        </ImageUploadListButton>
      )}
    </Column>
  );
};
